export const FORM_RESPONSE_TYPES = ['freeText', 'numberedText', 'numbersPickerWithout7'];
export type FormResponseType = (typeof FORM_RESPONSE_TYPES)[number];

export interface FormResponseOption {
  value: string;
  text: string;
}

export interface FormResponse {
  key: string;
  type: FormResponseType;
  description?: string;
  placeholder?: string;
  options?: FormResponseOption[];
}

export const FORM_QUESTION_TYPES = ['reflection', 'journal', 'pillarSurvey'];
export type FormQuestionType = (typeof FORM_QUESTION_TYPES)[number];

export interface ReflectionExtraData {
  quoteAuthor?: string;
  quoteText?: string;
  pillar?: string;
}

export interface FormQuestion {
  id: string;
  key?: string;
  extraData?: ReflectionExtraData;
  presentationText?: string;
  responses?: FormResponse[];
  text: string;
  type?: FormQuestionType;
}
